export default __webpack_public_path__ + "static/media/features-3.4edffdcb.gif";